module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.visible,
      "max-width": "960",
      "width": "960",
      "content-class": "premium-dialog"
    },
    on: {
      "input": _vm.onDialogInput
    }
  }, [_c('v-card', {
    staticClass: "pa-0 dialog-card"
  }, [_c('v-toolbar', {
    staticClass: "pt-2",
    attrs: {
      "flat": "",
      "color": "white",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "subheading font-weight-bold grey--text text--darken-2"
  }, [_vm._v("\n        NOVA SOLICITAÇÃO\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-6 pt-2 pb-5 dialog-body"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "form-grid",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-4 text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "headline primary--text font-weight-medium"
  }, [_vm._v("Solicitar Pagamento")]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text text--darken-1 mt-1"
  }, [_vm._v("Preencha os dados e anexe o boleto.")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "resumo-box"
  }, [_c('div', {
    staticClass: "caption grey--text text--darken-1"
  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
    staticClass: "subheading mt-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.form.descricao || 'Sem descrição'))])]), _vm._v(" "), _c('div', {
    staticClass: "title secondary--text mt-1"
  }, [_vm._v(_vm._s(_vm.valorPreview))]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text text--darken-1 mt-1"
  }, [_vm._v("\n                  Vencimento: " + _vm._s(_vm.form.data_vencimento ? _vm.formatDate(_vm.form.data_vencimento) : '--') + "\n                ")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "premium-input",
    attrs: {
      "label": "Descrição",
      "placeholder": "Ex: Manutenção Elétrica",
      "name": "descricao",
      "data-vv-as": "descrição",
      "error-messages": _vm.errors.has('descricao') ? _vm.errors.first('descricao') : []
    },
    model: {
      value: (_vm.form.descricao),
      callback: function($$v) {
        _vm.form.descricao = $$v
      },
      expression: "form.descricao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "field-label"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "premium-input",
    attrs: {
      "name": "valor",
      "data-vv-as": "valor",
      "placeholder": "Ex.: 1.250,90",
      "single-line": "",
      "hint": "Formato: 1.250,90",
      "persistent-hint": false,
      "error-messages": _vm.errors.has('valor') ? _vm.errors.first('valor') : []
    },
    on: {
      "input": _vm.onValorInput
    },
    model: {
      value: (_vm.form.valor),
      callback: function($$v) {
        _vm.form.valor = $$v
      },
      expression: "form.valor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "field-label"
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "premium-input",
    attrs: {
      "type": "date",
      "name": "data_vencimento",
      "data-vv-as": "vencimento",
      "single-line": "",
      "hint": _vm.form.data_vencimento ? ("Data selecionada: " + (_vm.formatDate(_vm.form.data_vencimento))) : 'Formato de exibição: dd/mm/aaaa',
      "persistent-hint": false,
      "error-messages": _vm.errors.has('data_vencimento') ? _vm.errors.first('data_vencimento') : []
    },
    model: {
      value: (_vm.form.data_vencimento),
      callback: function($$v) {
        _vm.form.data_vencimento = $$v
      },
      expression: "form.data_vencimento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "premium-input",
    attrs: {
      "items": _vm.users,
      "item-text": "name",
      "item-value": "id",
      "label": "Aprovador Responsável",
      "name": "aprovador",
      "data-vv-as": "aprovador",
      "error-messages": _vm.errors.has('aprovador') ? _vm.errors.first('aprovador') : []
    },
    model: {
      value: (_vm.form.aprovador_id),
      callback: function($$v) {
        _vm.form.aprovador_id = $$v
      },
      expression: "form.aprovador_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "upload-zone text-xs-center pa-4 mt-2",
    class: {
      'has-file': _vm.file
    },
    on: {
      "click": function($event) {
        _vm.$refs.fileInput.click()
      }
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*,application/pdf"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (!_vm.file) ? [_c('v-icon', {
    attrs: {
      "size": "32",
      "color": "grey lighten-1"
    }
  }, [_vm._v("cloud_upload")]), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text text--darken-1 mt-2"
  }, [_vm._v("Anexar Boleto")]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text lighten-1"
  }, [_vm._v("PDF ou Imagem (Máx 5MB)")])] : [_c('v-icon', {
    attrs: {
      "size": "32",
      "color": "green"
    }
  }, [_vm._v("check_circle_outline")]), _vm._v(" "), _c('div', {
    staticClass: "subheading green--text text--darken-1 mt-2 text-truncate",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.fileName) + "\n                  ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-1",
    attrs: {
      "small": "",
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetFile($event)
      }
    }
  }, [_vm._v("Trocar arquivo")])]], 2)])], 1)], 1)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-3 dialog-actions"
  }, [_c('v-btn', {
    staticClass: "font-weight-bold btn-cancelar",
    attrs: {
      "flat": "",
      "large": "",
      "color": "grey"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4 font-weight-bold btn-confirmar",
    attrs: {
      "depressed": "",
      "large": "",
      "color": "secondary",
      "disabled": _vm.isFormInvalid,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Solicitar Aprovação\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20a83356"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Pagamentos/PagamentosAdicionar.vue
// module id = 992
// module chunks = 1